<template>
  <main>
  <!-- ============================================================== -->
        <!-- Topbar header - style you can find in pages.scss -->
        <!-- ============================================================== -->
    <header class="topbar">
            <nav class="navbar top-navbar navbar-expand-md navbar-light">
                <!-- ============================================================== -->
                <!-- Logo -->
                <!-- ============================================================== -->
                <div class="navbar-header">
                   <router-link to="/" replace  class="navbar-brand">

                        <!-- Logo icon --><b>
                            <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->

                            <!-- Light Logo icon -->
                            <img src="/assets/images/adv_logo.png" alt="Advenue" class="light-logo" style="width:34px;height:34px;"/>
                        </b>
                        <!--End Logo icon -->
                        <!-- Logo text -->
                        <span style="display:none">
                         <!-- dark Logo text -->
                         <img src="/assets/images/logo-text.png" alt="Advenue" class="dark-logo" />
                         <!-- Light Logo text -->

                       </span>
                  </router-link>
                </div>
                <!-- ============================================================== -->
                <!-- End Logo -->
                <!-- ============================================================== -->
                <div class="navbar-collapse">
                    <!-- ============================================================== -->
                    <!-- toggle and nav items -->
                    <!-- ============================================================== -->
                    <ul class="navbar-nav mr-auto mt-md-0">
                        <!-- This is  -->
                        <li class="nav-item"> <a class="nav-link nav-toggler hidden-md-up text-muted waves-effect waves-dark"   @click="drawer = !drawer"><i class="mdi mdi-menu"></i></a> </li>
                        <li class="nav-item"> <a class="nav-link sidebartoggler hidden-sm-down text-muted waves-effect waves-dark" href="javascript:void(0)"><i class="ti-menu"></i></a> </li>
                        <li class="nav-item"> <span class="pull-left p-l-10 p-t-15"><h4 class="text-white">{{menuTitle}}</h4></span>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
         <!-- ============================================================== -->
        <!-- Left Sidebar - style you can find in sidebar.scss  -->
        <!-- ============================================================== -->
    <!-- <div class="text-xs-center">
         <v-dialog
            v-model="dialogturn"
            hide-overlay
            persistent
            width="300"
          >
               <v-card
                  color="primary"
                  dark
                >
                  <v-card-text>
                    Saved ....
                    <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0"
                    ></v-progress-linear>
                  </v-card-text>
              </v-card>
          </v-dialog>
       </div> -->
    <v-navigation-drawer
          class="left-sidebar sidebar-nav"
          v-model="drawer"
          app
          clipped
          hide-overlay
          id="style-1"
          style="top:57px"

        >
        <ul id="sidebarnav" style="overflow-x: visible;">
          <li>
                <div class="dw-user-box">
                   <!--  <div class="u-img"><img src="/assets/images/users/default.png" alt="user" class="thumb-lg"></div> -->
                    <div class="u-text">
                        <h4>{{user}}</h4>
                        <p class="text-muted pt">{{email}}</p>
                          <router-link to="/login" v-on:click.native="logOut()" replace  class="btn btn-rounded btn-secondary btn-sm">
                              Logout
                          </router-link>
                    </div>
                </div>
            </li>
            <li class="nav-devider"></li>
            <li  v-bind:class="menu_active('home')" >
                <router-link class="waves-effect waves-dark active" to="/" @click.native="open = false" aria-expanded="false">
                    <i class="mdi mdi-view-dashboard icon_setting"></i><span class="hide-menu">Dashboard</span>
                    <!-- class="fa fa-dashboard" -->
                </router-link>
            </li>
            <li v-bind:class="menu_active('campaign')" style="margin-top:-9px">
                <router-link class="waves-effect waves-dark" to="/campaign" @click.native="open = false" aria-expanded="false">
                   <i class="mdi mdi-view-list icon_setting"></i><span class="hide-menu">Campaign</span>
                </router-link>
            </li>
            <li v-bind:class="menu_active('')" style="margin-top:-9px">

            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" >
                <a  slot="activator" class="waves-effect waves-dark"><i class="mdi mdi-settings icon_setting"></i>
                    <span class="hide-menu" >Settings</span>
                </a>
                  <v-card>
                    <v-toolbar dark color="primary">
                      <v-btn icon dark @click.native="closeLeftMenu">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>

                      </v-btn>
                      <v-toolbar-title>Notification Settings</v-toolbar-title>
                      <v-spacer></v-spacer>
                       <v-spacer></v-spacer>
                      <v-toolbar-items class="closeButtonRight">

                      </v-toolbar-items>
                    </v-toolbar>
                    <v-list three-line subheader>


                        <v-list-tile avatar>

                            <v-list-tile-content>

                              <v-list-tile-sub-title class="txtspacetop">You receive notification</v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                              <v-switch :loading="loading" value input-value="true" v-if="dialogturn"></v-switch>

                                 <v-switch
                                 color="blue"

                                  class="swleft"
                                  :value="notificationsEnabled"
                                  :input-value="notificationsEnabled"
                                  @change="toggle($event !== null, $event)"
                                  v-else
                                 ></v-switch>
                            </v-list-tile-action>
                      </v-list-tile>
                    </v-list>


                  </v-card>
                </v-dialog>




               <!--  <router-link class="waves-effect waves-dark" to="/campaign" @click.native="open = false" aria-expanded="false">
                   <i class="fa fa-list-alt"></i><span class="hide-menu">Notification Settings</span>
                </router-link> -->
            </li>
        </ul>
    </v-navigation-drawer>
  </main>

</template>
<style scoped>
  .icon_setting{

    width: 27px;
    height: 34px;
    font-size: 21px;
    display: inline-block;
    vertical-align: middle;

  }
    .v-list__tile__content {
      display: inline-block !important;
      margin-top: -31px;
    }
    .sidebar-nav{
      z-index: 12;
    }
    .closeButtonRight{
      margin-right: -36px;
    }
   /* .noPadding{
      padding: 0px !important;
    }*/

    .v-toolbar__content>:last-child.v-btn--icon, .v-toolbar__extension>:last-child.v-btn--icon {
      margin-right: 6px;
    }
    .v-menu__content{
        width: 100%;
        height: 170px;
        top:55px !important;
        left:0px !important;
        max-width: 100% !important;
        background: #fff;
    }
    .btn-rounded.btn-sm{
        padding: 0.45rem .5rem !important;
    }
    .v-card__actions{
      padding: 16px !important;
    }
    .theme--light .v-sheet{
      height: 100%;
    }
    .v-btn {
       text-transform: none;
    }
    .v-list{
      padding-top: 18px !important;
      height: 120px;
    }

   .v-list__tile__action{
      display: -webkit-box !important;
      display: -ms-flexbox !important;

      min-width: 33px !important;;
   }
   .switch-center {
      display: flex;
      justify-content: center;
    }
    .switch-center {
      display: flex;
      justify-content: center;
    }
    .v-toolbar__title{
        font-size: 16px !important;
        font-weight: 400 !important;
    }
    .v-list__tile__sub-title{
         font-size: 16px !important;
         font-weight: 400 !important;
    }
    .txtspacetop{

       padding-top: 42px;
      /* margin-top: -16px !important;*/
    }
    .topbar{
       z-index: 180;
     }
     .v-dialog__content .v-dialog__content--active{
       z-index: 1400 !important;
     }
</style>
<script>
  import axios from 'axios';

  import { loginService } from '@/components/_service/Users.js';
  import { vapidKey } from '@/components/_service/Config.js';
  import { notificationservice} from '@/components/_service/Notification.js';
  const API_URL = process.env.API_URL || 'https://mobile.innity.com.my/apipost'
//import ServiceWorkerStorage from 'serviceworker-storage';
  //const storage = new ServiceWorkerStorage('sw:storage', 1);
  import MobileDetect from 'mobile-detect';
  import * as localforage from "localforage";

  // import axios from 'axios';
  // import { notificationservice} from '@/components/_service/Notification.js';
  // const API_URL = process.env.API_URL || 'https://mobile.innity.com.my/apipost'
  // import { loginService } from '@/components/_service/Users.js';
export default {
    props:['menuTitle'],
    data() {
        return {
            drawer:false,
            switch1:false,
            notifications: false,
            sound: true,
            widgets: false,
            dialog: false,

           items: [
            { title: 'Dashboard', icon: 'fa-dashboard',class:"active" },
            { title: 'Campaign', icon: 'fa-list-alt' },
          ],
          notificationsSupported: false,
          notificationsEnabled: false,
          buttonDisabled: false,
          serviceWorkerRegistation: null,
          subscription: null,
          dataSubscription:null,
          isSalePrivilege:false,
          userId:loginService.getSaleId(),
          userSubscriber:"",
          cssActive:"active",
          device:"",
          loading:"",
          dialogturn:false


        };
    },

    computed: {
          user () {
             if (localStorage.getItem("token")){
               var strUser = atob(localStorage.token);
               var arrayUser = strUser.split(",");
             // console.log(arrayUser)
                return arrayUser[1];
                //return JSON.parse(this.$store.state.user);

             }
          },
          email(){
              if (localStorage.getItem("token")){
               var strUser = atob(localStorage.token);
               var arrayUser = strUser.split(",");
             // console.log(arrayUser)
                return arrayUser[3];
                //return JSON.parse(this.$store.state.user);

             }
          }


    },
   async created() {

     this.isSalePrivilege =  await this.getsalePrivilege()
     //console.log(this.isSalePrivilege)

     if ('serviceWorker' in navigator && 'PushManager' in window) {

          this.notificationsSupported = true

          let start = Date.now();
          let times = [];

            setTimeout(function () {
               times.push(Date.now() - start);
              if (start + 100 < Date.now()) {
                    if (this.fstCheck && this.subscription != null) {

                      //console.log("send_notification");
                    //  this.createPushNotification1()
                    }else{
                      //console.log("dont send_notification")
                    }

              }else{

                 setTimeout(run); // else re-schedule
              }


            }.bind(this), 1000)

        }


    },
  async beforeUpdate(){


      if ( this.subscription == null){
          const value = await localforage.getItem('subscription');
          if (value){
            this.dataSubscription = value;
           //  console.log(value);
             this.notificationsEnabled = true
          }else{
             this.notificationsEnabled = false
          }
      }
      var str = navigator.userAgent;//navigator.userAgent;''

      var res = str.split(" ");
    //  console.log(res);
      var prefixPhone="";
      if (res[4]){
        prefixPhone =(res[3]+res[4] + res[5]);
        prefixPhone  = prefixPhone.replace("(","");
        prefixPhone  = prefixPhone.replace(")","");
      }

      var md = new MobileDetect(navigator.userAgent);
      var version = navigator.appVersion;
      let buildwedkit =  md.versionStr('Build');
      if (buildwedkit == null){
        buildwedkit =md.version('Webkit');
      }
      if (md.mobile()=='UnknownPhone'){
          this.device = res[4].replace(")","") +"-"+ md.os() +"-"+ buildwedkit +"-"+ prefixPhone;
      }else{
          this.device = md.mobile() +"-"+ md.os() +"-"+ buildwedkit +"-"+ prefixPhone;
      }


     // console.log( md );
     //console.log( md.userAgent() );

    //  console.log( this.device );          // 'Sony'

      //console.log(  this.device )
    },
   async mounted(){
        try {
           const value = await localforage.getItem('subscription');
        // This code runs once the value has been loaded
        // from the offline store.

           this.dataSubscription = value;
        } catch (err) {
            // This code runs if there were any errors.
            console.log(err);
        }


       //    this.getsalePrivilege();
     //    console.log(this.getsalePrivilege())

       //onsole.log(md)
        //

        notificationservice.findSubscription1()
            .then(sub => {
                if (sub === null) {
                 // if (subscriptionstorage){
                    this.buttonDisabled = false
                    this.notificationsEnabled = false

                  // }else{
                  //   this.buttonDisabled = false
                  //   this.notificationsEnabled = false
                  // }
                   //console.log('[mounted updated] no active subscription found on the client');

                } else {
                     //console.log('[mounted updated] Active subscription found');
                    // console.log(sub);
                    // retrieve user info from API
                   // console.log(this.dataSubscription)
                    if  (this.dataSubscription !== null){
                        this.buttonDisabled = false
                        this.notificationsEnabled = true
                        this.subscription = sub

                        this.handlePush(sub,this.flightcount,this.camcount,this.device);

                     }
                    //   sub.unsubscribe();
                    // }


                }
         })


         // notificationservice.findSubscription1()
         //    .then(sub => {
         //      //  console.log(sub +"ssssssss")
         //        if (sub === null) {

         //          //  console.log('[mounted updated] no active subscription found on the client');
         //            this.buttonDisabled = false
         //            this.notificationsEnabled = false
         //            this.notificationsSupported = false
         //            this.lblNotification ="Off"

         //        } else {
         //           // console.log('[mounted updated] Active subscription found', sub);
         //            // retrieve user info from API
         //            this.notificationsSupported = true
         //            this.buttonDisabled = true
         //            this.notificationsEnabled = true
         //            this.lblNotification ="On"
         //            this.subscription = sub

         //           // console.log(this.buttonDisabled)

         //           // this.handlePush(sub,this.flightcount,this.camcount);

         //        }
         //   })


    },
    methods: {

    getsalePrivilege(){
              this.$store.dispatch('checkCampaignAccess')
               .then(() =>

                  this.loading =false

                )
               .catch(err => {
                  console.log(err )

               })

               return  loginService.getAIOAcess().then((data)=>{
                    this.isSalePrivilege = data.approve_campaign ;
                 // console.log("data",data.approve_flight_request);
                    return data.approve_campaign;
                });
      },
     async  handlePush(newSubscription,flightcount,camcount,device) {

      let  oldSubscription =  await localforage.getItem('subscription'); //await storage.getItem('subscription');

        if(newSubscription.endpoint !== oldSubscription) {
          // localforage.removeItem('subscription')

          // localforage.setItem('subscription', newSubscription.endpoint);
          // const req = new Request(`${API_URL}/push.php`, {
          // method: 'POST',
          // body: JSON.stringify(
          //       {
          //         oldSubscription:oldSubscription,
          //         newSubscription: newSubscription,
          //         userId:this.userId,
          //         flightcount: flightcount,
          //         camcount : camcount,
          //         device:device,
          //         isSalePrivilege:this.isSalePrivilege,
          //         axn:"refreshpushsubscription",
          //       }
          //     )
          // });
          // const response =  self.fetch(req);
       }else{
         const req = new Request(`${API_URL}/push.php`, {
          method: 'POST',
          body: JSON.stringify(
                {
                  oldSubscription:oldSubscription,
                  newSubscription: newSubscription,
                  userId:this.userId,
                  device:device,
                  axn:"userexit",
                }
              )
          });
          const response =  self.fetch(req);
      }

      },

       menu_active(item){

            try{
                if (item ==this.$route.name){
                    return this.cssActive
                }
                // }else{
                //    return this.cssActive
                // }

            }catch(e){

                  console.log(e)
            }
          },
          showloading(isSubscription){
              if (isSubscription ){
                 return "warning";
              }else{
                return "";
              }
          },


        closeLeftMenu:function(){

            this.drawer = false;
            this.dialog = false;
        },
        logOut: function() {
             this.$store.dispatch('logout')
            .then(() => {
            //  window.location.href = '/login';
            this.$router.push('/login')
              //this.$router.go()
            })
        },
        getUserNotification(){
           return axios.post(`${API_URL}/push.php`, {
                    userId: this.userId,
                    axn:"userexit",
                }).then(response=> {

                const data = response.data;
                return data;



             })
        },
       toggle(value, event) {
     //   if (this.notificationsSupported) {
             console.log(`update1 ${value} ${event}`);
            this.buttonDisabled = true
            this.dialogturn = true;
          if (event && !this.notificationsEnabled){

            //console.log('notificationsEnabled' +this.notificationsEnabled)

            Notification.requestPermission()
                    .then(result => {

                        // if granted, create new subscription
                        if (result === 'granted') {
                        //  console.log(result);
                            notificationservice.createSubscription(this.subscription)
                            .then(sub => {
                              //  console.log('subscription created on the client', sub);
                                this.subscription = sub
                             //   console.log(this.createSubscription())
                                // get new (or existing user) from backend

                                //console.log('user created on the server', this.userId);
                                // store new subscription on the server
                                return axios.post(`${API_URL}/push.php`, {
                                    subscription: this.subscription,
                                    userId: this.userId,
                                    isSaleAccess: this.isSalePrivilege ,
                                    flightcount: this.flightcount,
                                    camcount : this.camcount,
                                    device:this.device,
                                    axn:"subscribe",
                                })

                            })
                            .then((result) => {
                                notificationservice.showNotification()
                                localforage.setItem('subscription',this.subscription.endpoint)
                                localforage.setItem('userId',this.userId)
                                localforage.setItem('device',this.device)
                               // console.log(this.subscription.endpoint)
                                // localStorage.setItem('isSubscription','1');
                                // localStorage.setItem('subscription',this.subscription.endpoint);
                                // storage.setItem('subscription',this.subscription.endpoint )
                                //storage.setItem('userId',this.userId )
                                this.buttonDisabled = false
                                value = this.notificationsEnabled = true
                                this.lblNotification ="On"
                                this.fstCheck= false
                                this.dialogturn = false;
                            })
                        } else {
                            //console.log('User did not granted permission')
                        }
                    })
          }else{



             // window.setTimeout( this.dialogturn=true, 10000 );
            //  console.log('Disable subscription' +  this.subscription);
             //  value = this.notificationsEnabled = false
              // value = this.notificationsEnabled = event
              // this.buttonDisabled = event


          //  if (this.subscription !== null) {
                  // destroy on the server


                  return axios.post(`${API_URL}/push.php`, {
                      endpoint: this.subscription.endpoint,
                      axn:"unsubscribe",
                      device:this.device,
                      userId: this.userId,
                  })
                  // unsubscribe on the client
                  .then(() => this.subscription.unsubscribe())
                  .then(() => {
                      // update the data

                      this.dialogturn=true;
                      value = this.notificationsEnabled = false
                      //localforage.removeItem('isSubscription');
                      this.fstCheck = true
                      localforage.removeItem('userId')
                      localforage.removeItem('subscription')
                      localforage.removeItem('device')
                      localforage.clear().then(function() {
                          // Run this code once the database has been entirely deleted.
                          console.log('Database is now empty.');
                      }).catch(function(err) {
                          // This code runs if there were any errors
                          console.log(err);
                      });

                      this.buttonDisabled = false

                      this.subscription = null
                      setTimeout(function () {
                          this.dialogturn = false
                      }.bind(this), 3000)


                    //  this.dialogturn = false;

                     console.log(this.dialogturn)
                  })
           //   }

            //  this.lblNotification ="On";
              //value = event
              console.log(`update ${value} ${event}`);
          }
        },
        // toggleSubscription() {

        //    console.log(this.subscription);
        //     if (this.notificationsSupported) {

        //         this.buttonDisabled = true
        //         // Find out if we need to create a subscription or delete it
        //         if (!this.notificationsEnabled) {

        //             console.log('notificationsEnabled' +this.notificationsEnabled)


        //          //   Ask permission and when granted, create new subscription
        //             Notification.requestPermission()
        //             .then(result => {
        //                 // if granted, create new subscription
        //                 if (result === 'granted') {
        //                     notificationservice.createSubscription()
        //                     .then(sub => {
        //                      //   console.log('subscription created on the client', sub);
        //                         this.subscription = sub
        //                      //   console.log(this.createSubscription())
        //                         // get new (or existing user) from backend

        //                         console.log('user created on the server', this.userId);
        //                         // store new subscription on the server
        //                         return axios.post(`${API_URL}/push.php`, {
        //                             subscription: this.subscription,
        //                             userId: this.userId,
        //                             isSaleAccess:this.$store.state.isSalePrivilege.approve_flight_request,
        //                             flightcount: this.flightcount,
        //                             camcount : this.camcount,
        //                             axn:"subscribe",
        //                         })
        //                     })
        //                     .then((result) => {
        //                         notificationservice.showNotification()
        //                        // console.log(this.subscription.endpoint)
        //                         storage.setItem('subscription',this.subscription.endpoint )
        //                         this.buttonDisabled = false
        //                         this.notificationsEnabled = true
        //                         this.lblNotification ="On"
        //                         this.fstCheck= false
        //                     })
        //                 } else {
        //                     //console.log('User did not granted permission')
        //                 }
        //             })
        //         } else {
        //             // Destroy subscription
        //             console.log('Disable subscription');

        //             if (this.subscription !== null) {
        //                 // destroy on the server
        //                 return axios.post(`${API_URL}/push.php`, {
        //                     endpoint: this.subscription.endpoint,
        //                     axn:"unsubscribe",
        //                     userId: this.userId,
        //                 })
        //                 // unsubscribe on the client
        //                 .then(() => this.subscription.unsubscribe())
        //                 .then(() => {
        //                     // update the data
        //                     this.fstCheck = true
        //                     storage.removeItem('subscription')
        //                     this.notificationsEnabled = false
        //                     this.buttonDisabled = false
        //                     this.lblNotification ="Off"
        //                     this.subscription = null

        //                 })
        //             }
        //         }
        //     }
        // },


    }
};
</script>
